export const FormQuestion = ({ question, options, selectedValue, onSelect, name }) => {
    const handleRadioChange = (option) => {
        console.log('Radio changed:', { name, option });
        if (onSelect) onSelect(option);
    };

    return (
        <div className="question-row">
            <div className="question-title d-flex align-items-center gap-2">
                <span>{question}</span>
            </div>
            <div>
                {options && options.length > 0 ? (
                    options.map((option, index) => {
                        const isSelected = selectedValue && selectedValue.includes(option.split(' - ')[0]);
                        console.log(`Option ${index}:`, { option, isSelected, selectedValue });
                        return (
                            <div key={index} className="option-item">
                                <input
                                    type="radio"
                                    name={name || question}
                                    value={option}
                                    checked={isSelected}
                                    onChange={() => handleRadioChange(option)}
                                    className="form-check-input"
                                    style={{ cursor: 'pointer' }}
                                />
                                <span className={`option-label ${isSelected ? 'checked-option' : ''}`}>
                                    {option}
                                </span>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-danger">No options available</div>
                )}
            </div>
        </div>
    );
}

export const MultiSelectQuestion = ({ question, options, selectedValues, onSelect, name }) => {
    const handleCheckboxChange = (option) => {
        const isCurrentlySelected = selectedValues && selectedValues.includes(option);
        let newValues;

        if (isCurrentlySelected) {
            newValues = selectedValues.filter(val => val !== option);
        } else {
            newValues = [...(selectedValues || []), option];
        }

        console.log('MultiSelect changed:', { option, isCurrentlySelected, newValues });
        onSelect(newValues);
    };

    return (
        <div className="question-row">
            <div className="question-title d-flex align-items-center gap-2">
                <span>{question}</span>
            </div>
            <div>
                {options && options.length > 0 ? (
                    options.map((option, index) => (
                        <div key={index} className="option-item">
                            <input
                                type="checkbox"
                                id={`${name}-${index}`}
                                name={name}
                                value={option}
                                checked={selectedValues && selectedValues.includes(option) ? true : false}
                                onChange={() => handleCheckboxChange(option)}
                                className="form-check-input"
                                style={{ cursor: 'pointer' }}
                            />
                            <label
                                htmlFor={`${name}-${index}`}
                                className={`option-label ${selectedValues && selectedValues.includes(option) ? 'checked-option' : ''}`}
                                style={{ cursor: 'pointer', marginLeft: '6px' }}
                            >
                                {option}
                            </label>
                        </div>
                    ))
                ) : (
                    <div className="text-danger">No options available</div>
                )}
            </div>
        </div>
    )
}